$(document).ready(
    function () {

        let p = $("body").attr("p");
        let a = $("body").attr("a");
        if (p === 'visit_tracker_visitor' && a === 'list') {

            let visit_tracker_visitor_search_ajax_lock = false;

            $(document).on("submit", "#visit_tracker_visitor_search_form", function (e) {

                e.preventDefault();

                if (!visit_tracker_visitor_search_ajax_lock) {

                    visit_tracker_visitor_search_ajax_lock = true;

                    $.ajax({
                        type: 'POST',
                        url: "/ajax/visit_tracker_visitor/search",
                        data: {
                            serialized_post: $(this).serialize()
                        }
                    })
                        .done(function (data) {

                            if (data.html !== undefined && data.html !== null) {
                                $('#visit-tracker-visitor-list').empty();
                                $('#visit-tracker-visitor-list').append(data.html);
                            }

                            appendSearchParamsToExportButtons();


                        })
                        .fail(function (data) {

                            if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
                                document.location.href = data.responseJSON.redirect_url;
                            }

                            visit_tracker_visitor_search_ajax_lock = false;

                        })
                        .always(function () {
                            visit_tracker_visitor_search_ajax_lock = false;
                        });

                }

                return false;

            });

            function appendSearchParamsToExportButtons() {
                let visitTrackerLocationId = $('#visit_tracker_location_id').val();
                let searchString = $('#search_string').val();
                let start = $('#start_date').val() + ' ' + $('#start_time').val() + ':00';
                let end = $('#end_date').val() + ' ' + $('#end_time').val() + ':59';
                let url = '/index.php?p=visit_tracker_visitor&a=download&visit_tracker_location_id=' + visitTrackerLocationId + '&search=' + searchString + '&start=' + start + '&end=' + end;
                $('#visitor-export-csv').attr('href', url + '&type=csv');
                $('#visitor-export-pdf').attr('href', url + '&type=pdf');
            }

        }

    }
);